<template>
  <el-table-column
    prop="to"
    sortable="custom"
    label="Helyettesítés vége"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.to">{{ scope.row.to | date }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'to',
  };
</script>
